/**
 * Represents an ISO 3166-1 alpha-2 country code identifier.
 * @see https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
 */
export enum Country {
  /**
   * Represents Andorra as an ISO 3166-1 alpha-2 country code identifier.
   */
  AD = 'AD',

  /**
   * Represents Albania as an ISO 3166-1 alpha-2 country code identifier.
   */
  AL = 'AL',

  /**
   * Represents Austria as an ISO 3166-1 alpha-2 country code identifier.
   */
  AT = 'AT',

  /**
   * Represents Australia as an ISO 3166-1 alpha-2 country code identifier.
   */
  AU = 'AU',

  /**
   * Represents Bosnia and Herzegovina as an ISO 3166-1 alpha-2 country code identifier.
   */
  BA = 'BA',

  /**
   * Represents Belgium as an ISO 3166-1 alpha-2 country code identifier.
   */
  BE = 'BE',

  /**
   * Represents Bulgaria as an ISO 3166-1 alpha-2 country code identifier.
   */
  BG = 'BG',

  /**
   * Represents Brazil as an ISO 3166-1 alpha-2 country code identifier.
   */
  BR = 'BR',

  /**
   * Represents Canada as an ISO 3166-1 alpha-2 country code identifier.
   */
  CA = 'CA',

  /**
   * Represents Chile as an ISO 3166-1 alpha-2 country code identifier.
   */
  CL = 'CL',

  /**
   * Represents China as an ISO 3166-1 alpha-2 country code identifier.
   */
  CN = 'CN',

  /**
   * Represents Colombia as an ISO 3166-1 alpha-2 country code identifier.
   */
  CO = 'CO',

  /**
   * Represents Cyprus as an ISO 3166-1 alpha-2 country code identifier.
   */
  CY = 'CY',

  /**
   * Represents Czech Republic as an ISO 3166-1 alpha-2 country code identifier.
   */
  CZ = 'CZ',

  /**
   * Represents Denmark as an ISO 3166-1 alpha-2 country code identifier.
   */
  DK = 'DK',

  /**
   * Represents Algeria as an ISO 3166-1 alpha-2 country code identifier.
   */
  DZ = 'DZ',

  /**
   * Represents Estonia as an ISO 3166-1 alpha-2 country code identifier.
   */
  EE = 'EE',

  /**
   * Represents Spain as an ISO 3166-1 alpha-2 country code identifier.
   */
  ES = 'ES',

  /**
   * Represents Finland as an ISO 3166-1 alpha-2 country code identifier.
   */
  FI = 'FI',

  /**
   * Represents France as an ISO 3166-1 alpha-2 country code identifier.
   */
  FR = 'FR',

  /**
   * Represents Great Britain as an ISO 3166-1 alpha-2 country code identifier.
   */
  GB = 'GB',

  /**
   * Represents Germany as an ISO 3166-1 alpha-2 country code identifier.
   */
  DE = 'DE',

  /**
   * Represents Greece as an ISO 3166-1 alpha-2 country code identifier.
   */
  GR = 'GR',

  /**
   * Represents Hong Kong.
   */
  HK = 'HK',

  /**
   * Represents Croatia as an ISO 3166-1 alpha-2 country code identifier.
   */
  HR = 'HR',

  /**
   * Represents Hungary as an ISO 3166-1 alpha-2 country code identifier.
   */
  HU = 'HU',

  /**
   * Represents Indonesia as an ISO 3166-1 alpha-2 country code identifier.
   */
  ID = 'ID',

  /**
   * Represents Ireland as an ISO 3166-1 alpha-2 country code identifier.
   */
  IE = 'IE',

  /**
   * Represents Israel as an ISO 3166-1 alpha-2 country code identifier.
   */
  IL = 'IL',

  /**
   * Represents Iceland as an ISO 3166-1 alpha-2 country code identifier.
   */
  IS = 'IS',

  /**
   * Represents Italy as an ISO 3166-1 alpha-2 country code identifier.
   */
  IT = 'IT',

  /**
   * Represents Jersey as an ISO 3166-1 alpha-2 country code identifier.
   */
  JE = 'JE',

  /**
   * Represents Japan as an ISO 3166-1 alpha-2 country code identifier.
   */
  JP = 'JP',

  /**
   * Represents South Korea as an ISO 3166-1 alpha-2 country code identifier.
   */
  KR = 'KR',

  /**
   * Represents Kazakhstan as an ISO 3166-1 alpha-2 country code identifier.
   */
  KZ = 'KZ',

  /**
   * Represents Latvia as an ISO 3166-1 alpha-2 country code identifier.
   */
  LV = 'LV',

  /**
   * Represents Lithuania as an ISO 3166-1 alpha-2 country code identifier.
   */
  LT = 'LT',

  /**
   * Represents Luxembourg as an ISO 3166-1 alpha-2 country code identifier.
   */
  LU = 'LU',

  /**
   * Represents Malta as an ISO 3166-1 alpha-2 country code identifier.
   */
  MT = 'MT',

  /**
   * Represents Morocco as an ISO 3166-1 alpha-2 country code identifier.
   */
  MA = 'MA',

  /**
   * Represents Monaco as an ISO 3166-1 alpha-2 country code identifier.
   */
  MC = 'MC',

  /**
   * Represents Moldova as an ISO 3166-1 alpha-2 country code identifier.
   */
  MD = 'MD',

  /**
   * Represents Montenegro as an ISO 3166-1 alpha-2 country code identifier.
   */
  ME = 'ME',

  /**
   * Represents North Macedonia as an ISO 3166-1 alpha-2 country code identifier.
   */
  MK = 'MK',

  /**
   * Represents the Netherlands as an ISO 3166-1 alpha-2 country code identifier.
   */
  NL = 'NL',

  /**
   * Represents Norway as an ISO 3166-1 alpha-2 country code identifier.
   */
  NO = 'NO',

  /**
   * Represents New Zealand as an ISO 3166-1 alpha-2 country code identifier.
   */
  NZ = 'NZ',

  /**
   * Represents Philippines as an ISO 3166-1 alpha-2 country code identifier.
   */
  PH = 'PH',

  /**
   * Represents Poland as an ISO 3166-1 alpha-2 country code identifier.
   */
  PL = 'PL',

  /**
   * Represents Portugal as an ISO 3166-1 alpha-2 country code identifier.
   */
  PT = 'PT',

  /**
   * Represents Réunion as an ISO 3166-1 alpha-2 country code identifier.
   */
  RE = 'RE',

  /**
   * Represents Romania as an ISO 3166-1 alpha-2 country code identifier.
   */
  RO = 'RO',

  /**
   * Represents Russia as an ISO 3166-1 alpha-2 country code identifier.
   */
  RU = 'RU',

  /**
   * Represents Serbia as an ISO 3166-1 alpha-2 country code identifier.
   */
  RS = 'RS',

  /**
   * Represents Sweden as an ISO 3166-1 alpha-2 country code identifier.
   */
  SE = 'SE',

  /**
   * Represents Singapore as an ISO 3166-1 alpha-2 country code identifier.
   */
  SG = 'SG',

  /**
   * Represents Slovakia as an ISO 3166-1 alpha-2 country code identifier.
   */
  SK = 'SK',

  /**
   * Represents Slovenia as an ISO 3166-1 alpha-2 country code identifier.
   */
  SI = 'SI',

  /**
   * Represents Switzerland as an ISO 3166-1 alpha-2 country code identifier.
   */
  CH = 'CH',

  /**
   * Represents Tunisia as an ISO 3166-1 alpha-2 country code identifier.
   */
  TN = 'TN',

  /**
   * Represents Turkey as an ISO 3166-1 alpha-2 country code identifier.
   */
  TR = 'TR',

  /**
   * Represents Taiwan as an ISO 3166-1 alpha-2 country code identifier.
   */
  TW = 'TW',

  /**
   * Represents United Arab Emirates as an ISO 3166-1 alpha-2 country code identifier.
   */
  AE = 'AE',

  /**
   * Represents United Kingdom as an ISO 3166-1 alpha-2 country code identifier.
   */
  UK = 'UK',

  /**
   * Represents the United States as an ISO 3166-1 alpha-2 country code identifier.
   */
  US = 'US',

  /**
   * Represents South Africa as an ISO 3166-1 alpha-2 country code identifier.
   */
  ZA = 'ZA'
}
